import { CdLogo } from '../../atoms/CdLogo';
import type { LinkComponent, NavItemConfig } from '../../types';
import { CdSideNav } from '../CdSideNav';
import { CdSidePanel } from '../CdSidePanel';
import styles from './CdMobileNavDrawer.module.scss';

export interface CdMobileNavDrawerProps {
  open: boolean;
  onClose: () => void;
  items: NavItemConfig[];
  isActive: (href: string) => boolean;
  linkComponent?: LinkComponent;
  footerText?: string;
}

/** Navigation drawer for small screens – the expanded SideNav inside a left SidePanel. */
export const CdMobileNavDrawer = ({
  open,
  onClose,
  items,
  isActive,
  linkComponent,
  footerText,
}: CdMobileNavDrawerProps) => {
  return (
    <CdSidePanel
      open={open}
      onClose={onClose}
      title="Navigation"
      hideTitle
      side="left"
      tone="nav"
      closeLabel="Close navigation"
      headerActions={<CdLogo tone="onDark" className={styles.logo} />}
    >
      <CdSideNav
        items={items}
        isActive={isActive}
        linkComponent={linkComponent}
        footerText={footerText}
        onNavigate={onClose}
        hideBrand
        className={styles.nav}
      />
    </CdSidePanel>
  );
};
